/**
 * Created by alex.y on 9/21/2017.
 */
import {Directive, forwardRef, Input, SimpleChanges} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {Location} from "../../../objects/management/locationManagement/location";

@Directive({
    selector: '[validateCalcLocation][ngControl],[validateCalcLocation][ngFormControl],[validateCalcLocation][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => LocationCalcValidatorDirective), multi: true}
    ]
})
export class LocationCalcValidatorDirective implements Validator {
    @Input('validateCalcLocation') locationTo: Location;

    constructor() {
    }

    private onChange: () => void;

    validate(control: AbstractControl): { [key: string]: any } {
        if (!this.locationTo)
            return null;

        let pattern = /.*(Canada|USA|United States).*/i;
        if ((!this.locationTo.Country.match(pattern)))
            return {validateCalcLocation: false};


        return null;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/validators/calcLocationValidator.ts